import ViewExportContainer from '../ViewExport/ViewExportContainer';

import { formatDate } from '../../utils';

const getTableData = (data, columns) => {
  const headers = columns
    .filter(({ id }) => id !== 'actions')
    .map(({ Header }) => Header);
  const rows = [];
  data.forEach(({ id, startIp, endIp, name, updatedAt }) => {
    rows.push([
      String(id),
      ` ${startIp}`, // to avoid ip address being treated as img
      ` ${endIp}`,
      ` ${name}`,
      formatDate(updatedAt),
    ]);
  });
  return { headers, rows };
};

const IPManagementExport = (props) => (
  <ViewExportContainer {...props} getTableData={getTableData} />
);

export default IPManagementExport;
